// extracted by mini-css-extract-plugin
export var button = "_mg-0";
export var donut = "_mg-1";
export var donutFill = "_mg-3";
export var donutTrack = "_mg-2";